import { tool as MOUNT_ID } from '@src/constants/mount-id.FLAVOUR';
import URLS from '@src/constants/urls';
import { mountIframe, initEventHandlers } from '@src/helpers/mountIframe';

// to run app using a build from a feature branch or master but not using production iframe path,
// set global.fritsAppOptions.iframeDomain before loading this script.

((appOptions = {}) => {
  const iframe = mountIframe({
    ...appOptions,
    id: MOUNT_ID.vriendenhypotheek,
    path: URLS.includeVriendenhypotheekTool,
  });

  initEventHandlers({ iframe, appOptions });
})(global.fritsAppOptions);
